var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplayLogoV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6846 17.1578L16.5798 14.105L5.18202 25.3446L19.6846 17.1578ZM19.6846 8.84758L5.18202 0.660833L16.5798 11.9004L19.6846 8.84758ZM24.2292 14.5459C25.1587 13.8201 25.1587 12.1842 24.1674 11.4584L21.1254 9.72725L17.7314 13.0033L21.1254 16.2793L24.2292 14.5459ZM2.2061 26L15.4596 12.9978L2.2061 0.00108333V0C1.53552 0.345583 1.08594 0.975 1.08594 1.79292V24.2071C1.08594 25.025 1.53552 25.6544 2.2061 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayLogoV2);
export default __webpack_public_path__ + "static/media/googleplay-logo-v2.5bdd3acbefa85154151e6c8d77eaf6b2.svg";
export { ForwardRef as ReactComponent };